export const version = '2.65.1';
//# sourceMappingURL=version.js.map